import React from 'react'
import clsx from 'clsx'
import Box from '@node-space/storybook-components/dist/Box'

export interface ErrorTextProps {
  text: string
  onErrorClick?: () => void
  testid?: string
}

const ErrorText = ({ text, onErrorClick, testid }: ErrorTextProps) => {
  return (
    <Box
      testid={testid}
      className={clsx('mt-1 text-xs text-status-accent-error', onErrorClick && 'cursor-pointer')}
      {...(onErrorClick && { onClick: onErrorClick })}
    >
      {text}
    </Box>
  )
}
export default ErrorText
